import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-activite-professionnels',
  standalone: true,
  imports: [CommonModule, RouterModule, PageLayoutComponent],
  templateUrl: './assurance-activite-professionnels.component.html',
  styleUrls: ['./assurance-activite-professionnels.component.scss']
})
export class AssuranceActiviteProfessionnelsComponent {
  title = 'Assurance de l\'Activité des Professionnels et Entreprises';
  subtitle = '';
  heroImage = 'assets/static_pages_images/Forges_et_laminoirs.jpg';

  breadcrumbs = [
    { label: 'Entreprises', link: undefined },
    { label: 'Assurance de l\'Activité', link: undefined }
  ];

  prevPage = { title: 'Assurance des Biens pour Professionnels et Entreprises',
    link: '/assurance-biens-professionnels'
  };

  nextPage = { title: 'Autres Assurances',
    link: '/autres-assurances'
  };

  constructor(private router: Router) {}

  navigateToComparison(): void {
    this.router.navigate(['/cac/comparaison']);
  }
}
